import { FC } from "react";
import cn from "classnames"
import { ProfileIcon } from "src/assets/Icons";
import { AvatarClassNames } from "./constants";

const Avatar: FC<{
  imgUrl?: string;
  style?: React.CSSProperties;
  classNames?: AvatarClassNames;
  avatarSize?:number;
}> = ({
  imgUrl,
  style,
  classNames,
  avatarSize,
}) => {
  return (
    <div
      style={{ width: avatarSize, height: avatarSize, ...style }}
      className={cn("absolute overflow-hidden rounded-md border-2 border-background-default bg-background-primary/50", classNames?.avatar)}
    >
      {imgUrl ? (
        <img src={imgUrl} className={cn("h-full w-full object-cover", classNames?.avatarImage)} />
      ) : (
        <div className={cn("flex h-full w-full items-center justify-center", classNames?.avatarFallback)}>
          <ProfileIcon width={18} height={18} className="text-font-active"/>
        </div>
      )}
    </div>
  );
};

const AvatarStack: FC<{
  items: {imgUrl?: string}[];
  imgOverflowCount: number;
  className?: string;
  classNames?: AvatarClassNames;
  overlapRatio?:number;
  avatarSize?:number;
}> = ({
  items,
  imgOverflowCount,
  className,
  classNames,
  avatarSize = 32,
  overlapRatio = 0.3,
}) => {
  const visibleItems = items?.slice(0, imgOverflowCount);
  const hiddenCount = items?.length - imgOverflowCount;
  const totalSlots = visibleItems?.length + (hiddenCount > 0 ? 1 : 0);
  const avatarStep = avatarSize * (1-overlapRatio);
  const containerWidth = avatarSize + avatarStep * (totalSlots - 1);

  return (
    <div className={cn("relative", className)} style={{ width: containerWidth, height: avatarSize }}>
      {visibleItems?.map((item, index) => (
        <Avatar key={index} imgUrl={item.imgUrl} style={{ left: index * avatarStep, zIndex: index }} classNames={classNames} avatarSize={avatarSize} />
      ))}
      {hiddenCount > 0 && (
        <div
          className={cn("bg-background-primary/25 absolute flex items-center justify-center rounded-md border-2 border-background-default text-xs font-medium", classNames?.avatarOverflow)}
          style={{
            width: avatarSize,
            height: avatarSize,
            left: visibleItems?.length * avatarStep,
            zIndex: visibleItems?.length,
          }}
        >
          +{hiddenCount}
        </div>
      )}
    </div>
  );
};

export default AvatarStack;